export function isWebUrlValid(url?: string | null): boolean {
  if (!url) return false;

  try {
    const trimmedUrl = url.trim();

    // Check if URL has a protocol, if not assume https://
    const urlWithProtocol = /^https?:\/\//i.test(trimmedUrl)
      ? trimmedUrl
      : `https://${trimmedUrl}`;

    const urlObject = new URL(urlWithProtocol);

    // Must have http or https protocol
    if (!['http:', 'https:'].includes(urlObject.protocol)) {
      return false;
    }

    // Must have a valid hostname
    if (!urlObject.hostname || urlObject.hostname.length === 0) {
      return false;
    }

    // Hostname must contain at least one dot (for TLD)
    if (!urlObject.hostname.includes('.')) {
      return false;
    }

    return true;
  } catch {
    return false;
  }
}
